import type { Kenmerk, KenmerkLookup } from '../../types';

export type KenmerkSearchMatch = {
  groupName: string;
  kenmerk: Kenmerk;
};

const normalize = (value: string): string => value.trim().toLowerCase();

const findKenmerkenByQuery = (
  kenmerkLookup: KenmerkLookup,
  query: string,
): Array<KenmerkSearchMatch> => {
  const normalizedQuery = normalize(query);

  if (normalizedQuery === '') return [];

  const matches: Array<KenmerkSearchMatch> = [];

  for (const groupName of Object.keys(kenmerkLookup)) {
    for (const kenmerk of kenmerkLookup[groupName]) {
      if (normalize(kenmerk.description).includes(normalizedQuery)) {
        matches.push({ groupName, kenmerk });
      }
    }
  }

  return matches;
};

export default findKenmerkenByQuery;
